import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  margin-right: 0;
  margin-left: 0;
  padding: 16px;
  border: 2px solid #797c7f;
`;

function PrimaryPartnerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Primary Partner Information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerFirstName)}
            label={getFieldProps(FORM_FIELD_KEYS.primaryPartnerFirstName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.primaryPartnerFirstName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerMiddleName)}
            label={getFieldProps(FORM_FIELD_KEYS.primaryPartnerMiddleName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.primaryPartnerMiddleName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerLastName)}
            label={getFieldProps(FORM_FIELD_KEYS.primaryPartnerLastName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.primaryPartnerLastName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerTitle)}
            label={getFieldProps(FORM_FIELD_KEYS.primaryPartnerTitle)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerTitle)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.primaryPartnerTitle]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerSuffixName)}
            label={getFieldProps(FORM_FIELD_KEYS.primaryPartnerSuffixName)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerSuffixName)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.primaryPartnerSuffixName]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerSSN)}
            label="Social Security Number"
            placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerSSN)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.primaryPartnerSSN]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default PrimaryPartnerInfoBlock;
